import getOffsetValue from "./get-offset-value";

/**
 *
 * @param {String} input
 * @param {Number} previous
 * @param {Boolean} hasOffset
 * @param {Boolean} coords
 * @returns {Map<"offset" | "previous" | "original" | "skip" , any>}
 */
const getOffset = (input, previous, hasOffset, coords) => {
  let current = 0;
  let original = "";

  const map = new Map();
  const split = input.split("_[");

  original = hasOffset ? split[1].slice(0, -1) : split[0].slice(1, -1);

  if (hasOffset) {
    const range = split[0].split("-");
    current = getOffsetValue(range[range.length - 1], coords, input);

    if (range.length > 1) {
      previous = getOffsetValue(range[0], coords, input);
    }
  } else {
    if (coords) {
      current = previous + 100;
    } else {
      current = previous + 400;
    }
  }

  map.set("offset", current);
  map.set("previous", previous);
  map.set("original", original);

  return map;
};

export default getOffset;
